import React, { useState,useRef, useEffect } from 'react';
import {
  TextField,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  MenuItem,
  Box,
  Paper,
  Tab,
  Tabs,
  TextareaAutosize
} from '@mui/material';
import useApi from '../../api/useApi';
import { ClassTeacherCreate } from '../../api/teacherService';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router';
import { OrgCreate } from '../../api/orgService';
// import { Form, TextArea } from 'semantic-ui-react'
// import { useNavigationTab } from '../../hooks/useNavigationTab';


const OrgCreateForm = ({allTopics,allSubtopics,setSelected}) => {
  const navigate = useNavigate()

  const [form, setForm] = useState({
    org_name: '',
    org_description: '',
    org_tag: '',
  });

  const { user } = useAuth();
  // const navigate=useNavigate()
  // const {customNavigate} = useNavigationTab()

  const { request:createOrg,data:createOrgData,error:createOrgError,isLoading:createOrgIsLoading}=useApi(OrgCreate)


  const handleChange = (e) => {
    // setForm({ ...form, [e.target.name]: e.target.value });
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));    
  };

  // const handleFormUrlChange = (e,res) => {
  //   setForm({ ...form, [e.target.name]: res });
  // };

  
 

  useEffect(()=>{
    if(createOrgData){
      if(createOrgData?.status===201){
        toast.success(`${JSON.stringify(createOrgData?.statusText)}, successful`,{position: "top-center"});
        // customNavigate("/t","","home",{refresh:"classes"})
        navigate("/staff/organisations")
      }
    }
  },[createOrgData])

  useEffect(()=>{
    if(createOrgError){

        toast.error(`${JSON.stringify(createOrgError?.response?.data,null,2)}`,{position: "top-center"});
    }
  },[createOrgError])


  const firstPart = form?.org_description?.slice(0, 150);
  const extraPart = form?.org_description?.slice(150);
  const  okayToSubmit = !extraPart?.length===0 || !form.org_name?.length>0 || !form.org_description?.length>15 || !form.org_tag?.length>0 

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Material Created:', form);
    form.created_by = user?.user?.id
    const dataToSend = {
      org_name: form.org_name,
      org_description: form.org_description.slice(0, 150),
      org_tag: form.org_tag,
    }
    createOrg(dataToSend)

    // Add API request logic here
  };
  return (
    <Box display="flex" justifyContent="center" width="100%">
    <Box display="flex" flexDirection="column" justifyContent="center" mt={4} width={700}>

        <div>
          
          <Typography variant="h5" gutterBottom>
            Create a new Organisation
          </Typography>
        </div>
          
          <Typography variant='p' component="p" color='#404040'>
          An organisation is the entity being represented by the system as the owner of activities, projects, campaigns published to this website through this system. This may also include branches and subsidiaries.
          </Typography>
          <form onSubmit={handleSubmit} style={{marginTop:30}}>
            
          <i>Required fields are marked with an asterisk (*).</i>

            <TextField
              fullWidth
              label="Organisation Name"
              name="org_name"
              value={form.org_name}
              onChange={handleChange}
              margin="normal"
              required
              
            />

            <TextField
              fullWidth
              label="Organisation tag Name"
              name="org_tag"
              value={form.org_tag}
              onChange={handleChange}
              margin="normal"
              required
            />

            <Typography variant='p' component="p" color='#404040'>
            Write a brief, informative description that explains about the organisation.
            </Typography>

          <TextField
              fullWidth
              label="Organisation description"
              name="org_description"
              value={form.org_description}
              onChange={handleChange}
              margin="normal"
              required
            />
           
           
            {/* <Form>
              <TextArea placeholder='About your organisation ...' 
              name="org_description"
              value={form?.org_description}
              onChange={handleChange} />
            </Form> */}

            {/* <Box
              width="100%"
              height="30%"
              sx={{
                pointerEvents: "none",
                color: "black",
                whiteSpace: "pre-wrap",
                padding: "16.5px 14px",
                fontFamily: "Roboto, sans-serif",
                fontSize: "1rem",
              }}
            >
              {firstPart}
              <span style={{ color: "gray" }}>{extraPart}</span>
            </Box> */}

            
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 1 ,mb:5}}
              disabled={okayToSubmit}
            >
              Create Organisation
            </Button>
          </form>
      </Box>
    </Box>
  );
};


export default OrgCreateForm